// «Ir a la conversación» (PARITY P255): the first Tab stop on the page, visible only while focused.
// Jumps past the team strip and the conversation list to the composer (or the main pane).
import { t } from '../../i18n/i18n';

export function SkipToMain() {
  return (
    <a
      className="skip-link"
      href="#main"
      onClick={(e) => {
        e.preventDefault();
        const target =
          document.querySelector<HTMLElement>('.workspace-main .composer textarea, .workspace-main textarea') ??
          document.querySelector<HTMLElement>('.workspace-main .conversation-pane, .workspace-main section');
        if (!target) return;
        if (!target.matches('textarea, input, button, a, [tabindex]')) target.tabIndex = -1;
        target.focus();
      }}
    >
      {t('web.a11y.skipToConversation')}
    </a>
  );
}
